import NoteComment from '~/scripts/services/model/note-comment';
import NoteContext from '~/scripts/services/model/note-context';

// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevCommentsController {
	/* @ngInject */
	constructor() {
		this.data = [
			new NoteContext({
				kid:          'K_NODE;xxxxx',
				linkto:       [
					{
						kid:  'K_NODE;0000045M8L5DHQN0JI9U',
						name: 'image.png',
					},
				],
				notes:        [
					new NoteComment({
						author:       'K_NODE;KP_OLIVIER',
						content: '<p>ceci est mon commentaire n°1</p>',
						date:         new Date('2023-10-18 15:13:51'),
						kid:     'K_NODE;ZEFEZRF42F',
						replies: [
							new NoteComment({
								author:       'K_NODE;KP_OLIVIER',
								content: '<p>réponse au commentaire n°1</p>',
								date:         new Date('2023-10-19 09:48:34'),
								kid:     'K_NODE;CHQROIGHAL',
								replies: [],
							}),
						],
					}),
					new NoteComment({
						author:       'K_NODE;KP_FRED',
						date:         new Date('2023-10-19 11:01:09'),
						content: '<p>ceci est mon commentaire n°2</p>',
						kid:     'K_NODE;OJRTHJZLERJ',
						replies: [],
					}),
				],
				owner:        'K_NODE;KP_OLIVIER',
				participants: [
					{
						kid:  'K_NODE;KP_OLIVIER',
						name: 'Olivier Béraud',
					},
					{
						kid:  'K_NODE;KP_FRED',
						name: 'Frédéric Desforges',
					},
				],
				type:         'K_NODE;KNOTECTXTYPE_perso',
			}),
		];

		this.myForm = {};
		this.readOnly = false;
		this.settings = {
			options: {
				defaultType: 'K_NODE;KNOTECTXTYPE_perso',
				showTypes:   true,
			},
		};
	}
}
